import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

export function KpiCard({
  label,
  value,
  delta,
  hint,
  color = "primary.main",
  /** Прогресс к цели (0-100), рисуется как узкая полоса под подсказкой (ТЗ §2.1 «Регистрация» — плитка с целью месяца). */
  progress,
}: {
  label: string;
  value: string;
  delta?: string;
  hint?: string;
  color?: string;
  progress?: number;
}) {
  const deltaIsNegative = delta?.trim().startsWith("-");
  return (
    <Paper variant="outlined" sx={{ p: 2.5, height: "100%" }}>
      <Stack spacing={0.75}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h5" fontWeight={700} color={color}>
          {value}
        </Typography>
        {delta && (
          <Box>
            <Typography
              component="span"
              variant="caption"
              fontWeight={600}
              color={deltaIsNegative ? "error.main" : "success.main"}
            >
              {delta}
            </Typography>
            {hint && (
              <Typography component="span" variant="caption" color="text.secondary">
                {" "}
                {hint}
              </Typography>
            )}
          </Box>
        )}
        {!delta && hint && (
          <Typography variant="caption" color="text.secondary">
            {hint}
          </Typography>
        )}
        {typeof progress === "number" && (
          <LinearProgress variant="determinate" value={Math.min(100, Math.max(0, progress))} sx={{ borderRadius: 1, height: 6 }} />
        )}
      </Stack>
    </Paper>
  );
}
